































import { Component, Prop, Vue } from 'vue-property-decorator';
import { V2ProductGuideBrandViewObject } from '@/types/apiServerContract';
import SearchPageBrandProductGuideOverlayService
    from '@/project/modals/overlays/SearchPageBrandProductGuideOverlay.service';
import { UrlQueryKey } from '@/core/urlQueryKey';
import { softRedirect } from '@/core/redirect.service';
import serverContextService from '@/core/serverContext.service';
import loggingService from '@/core/logging.service';

@Component({})
export default class BrandProductGuideBanner extends Vue {
    @Prop() guideBrands!: V2ProductGuideBrandViewObject[];

    async handleClickProductGuideBanner() {
        const result = await SearchPageBrandProductGuideOverlayService.show({
            brands: this.guideBrands
        });
        if (result) {
            const params: string = (result.guide[UrlQueryKey.productGuideId])
                ? `${UrlQueryKey.productGuideId}=${result.guide[UrlQueryKey.productGuideId]}`
                : `${UrlQueryKey.productGuideKey}=${result.guide[UrlQueryKey.productGuideKey]}`;
            if (result?.guide?.productGuideUrl) {
                softRedirect(`${result.guide.productGuideUrl}?${UrlQueryKey.productGuideBrandName}=${result.guide[UrlQueryKey.productGuideBrandName]}&${params}`);
            } else {
                loggingService.info('Product guide URL not found');
            }
        }
    }

    brandLogoUrl(brandName: string): string {
        return `${serverContextService.productMediaUrl}/logos_static/${brandName}.png`;
    }

    get bannerIcon(): string {
        return serverContextService.settings.productGuideBannerIcon;
    }

    get bannerBackgroundImage(): string {
        return serverContextService.settings.productGuideBannerBackground;
    }

    get bannerStyle(): Partial<CSSStyleDeclaration> {
        const styling: Partial<CSSStyleDeclaration> = {};
        if (this.bannerBackgroundImage) {
            styling.backgroundImage = `url(${this.bannerBackgroundImage})`;
        }
        return styling;
    }
}
